module.exports = __webpack_public_path__ + "img/Marine-Reg-1.63d75e70.png";